<template>
  <div>
    <v-app-bar
      dense
      flat
      height="50"
    >
      <v-row align="center">
        <v-col
          xs="12"
          sm="5"
          md="4"
          class="d-none d-sm-flex"
        >
          <search-field
            :search-text="searchText"
            :status="status"
            @statusChange="changeStatus"
            @search="onSearch"
          />            
        </v-col>
        <v-col
          xs="12"
          sm="7"
          md="8"
          class="d-none d-sm-flex justify-end align-center"
        >
          <v-btn
            id="user_refresh"
            color="primary"
            :loading="loader"
            class="mr-2 elevation-0"
            @click.native="reload()"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <create-form
            :user-id="selectedUserId"
            :open.sync="userForm"
            @refresh="reload"
          />
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                id="user_add"
                slot="activator"
                class="elevation-0"
                color="success"
                @click="openUserForm()"
                v-on="on"
              >
                <v-icon>mdi-plus</v-icon>Invite User
              </v-btn>
            </template>
            <span>Invite a new user</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-app-bar>
    <v-card
      flat
      outlined
      tile
    >
      <v-card-text>
        <v-row>
          <v-col
            xs="12"
            class="d-flex d-sm-none"
          >
            <search-field
              :search-text="searchText"
              :status="status"
              @statusChange="changeStatus"
              @search="onSearch"
            />            
          </v-col>
        </v-row>
        <v-row>
          <v-col
            xs="12"
            class="pa-0"
          >
            <v-data-table
              :headers="headers"
              :items="users"
              :items-per-page="limit"
              :loading="loader"
              hide-default-footer
              mobile-breakpoint="0"
            >
              <!-- Role column -->
              <template v-slot:[`item.isAdmin`]="{ item }">
                <v-chip
                  outlined
                  label
                  color="success--text"
                >
                  {{ item.isAdmin ? "ADMIN*" : item.role.name }}
                </v-chip>
              </template>

              <!-- Status column -->
              <template v-slot:[`item.activeStatus`]="{ item }">
                <v-chip
                  v-if="item.activeStatus"
                  outlined
                  label
                  color="success--text"
                >
                  Active
                </v-chip>
                <v-chip
                  v-else
                  outlined
                  label
                  color="error--text"
                >
                  In-active
                </v-chip>
              </template>

              <!-- verified column -->
              <template v-slot:[`item.verified`]="{ item }">
                <v-chip
                  v-if="item.verified"
                  outlined
                  label
                  color="success--text"
                >
                  verified
                </v-chip>
                <v-chip
                  v-else
                  outlined
                  label
                  color="error--text"
                >
                  Not verified
                </v-chip>
              </template>

              <!-- Actions column -->
              <template v-slot:[`item.actions`]="{ item }">
                <user-options
                  :user-id="item.id"
                  :active="item.activeStatus"
                  :verified="item.verified"
                  @reload="getUsers()"
                />
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions v-show="totalPage > 1">
        <v-row>
          <v-col>
            <v-pagination
              v-model="page"
              :length="totalPage"
              @input="getUsers()"
            />
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { failure, pagination } from "@/mixins/common";
import UserOptions from "@/components/user/UserOptions";
import CreateForm from "@/components/user/UserForm";
import SearchField from "@/components/utils/SearchField";

export default {
  name: "UserList",
  components: {
    UserOptions,
    CreateForm,
    SearchField
  },
  mixins: [failure, pagination],
  data() {
    return {
      loader: false,
      users: [],
      searchText: null,
      page: 1,
      totalPage: 0,
      status: "",
      userForm: false,
      selectedUserId: 0,
      headers: [
        { text: "Name", value: "name", sortable: false },
        { text: "Email", value: "email", align: "center", sortable: false },
        { text: "Admin Status", value: "isAdmin", align: "center" , sortable: false},
        { text: "Active Status", value: "activeStatus", align: "center", sortable: false },
        { text: "Verified", value: "verified", align: "center", sortable: false },
        { text: "Option", value: "actions", align: "center", sortable: false }
      ]
    };
  },
  created() {
    this.init();
  },
  methods: {
    getUsers() {
      this.loader = true;
      let url = `${this.ADMIN_API_URL}/users?page=${
        this.page - 1
      }&sort_key=name&limit=${this.limit}&status=${this.status}`;
      if (this.searchText) {
        url += `&search=${this.searchText}`;
      }
      this.$http.get(url).then(
        (res) => {
          this.users = res.body.data || [];
          this.totalPage = res.body.totalPage;
          this.page = res.body.pagination.page + 1;
          this.loader = false;
        },
        (failure) => {
          this.handleFailure(failure);
        }
      );
    },
    search() {
      this.page = 1;
      this.getUsers();
    },
    reload() {
      this.searchText = null;
      this.status = "";
			this.search();
		},
    onSearch(val) {
      this.searchText = val;
      if (!val || val.length >= 3) {
        this.search();
      }
    },
		changeStatus(status) {
			this.status = status;
			this.search();
    },
    openUserForm(id = 0) {
      this.selectedUserId = id;
      this.userForm = true;
    },

    init() {
      this.getUsers();
    },

    sendVerifyMail(item){
      console.log("Selected Item :",item);
      
    }
  }
};
</script>
